export default {
    intro: '초성과 뜻을 단서로 어휘를 추리해 보세요!',
    meaning: '뜻',
    example: '예',
    table: {
        question: '어휘',
        emptyMessage: '내용이 없어요.',
        answerRate: '정답률',
    },
    student: {
        selectionGuide: '이 정보를 보고 어떤 어휘인지 알 수 있나요?',
        know: '알아요!',
        dontKnow: '몰라요',
        submit: '제출하기',
        next: '다음으로',
        inputGuide: '생각한 어휘를 입력해보세요!',
        inputPlaceholder: '정답을 입력해주세요',
        meaningN: '뜻 {n}',
        imageN: '이미지 {n}',
        videoN: '영상 {n}',
        additionalMaterials: '추가 자료',
    },
    result: {
        myAnswer: '내 답변:',
        know: '알아요',
        dontKnow: '몰라요',
        dontKnowBracket: '(몰라요)',
    },
    stats: {
        mostIncorrect: '많이 틀린 어휘',
        vocabulary: '어휘',
        meaning: '뜻',
        accuracy: '정답률',
        moreN: '외 {n}개',
    },
    reactions: {
        knowSelect: [
            '오! 자신감이 넘치는데요?',
            '그래요! 한번 확인해 볼까요?',
            '좋아요! 정말 맞는지 볼게요!',
            '훌륭해요! 어떤 어휘일까요?',
            '멋져요! 답을 확인해 봐요!',
        ],
        correct: [
            '정답이에요! 정말 잘했어요!',
            '와! 완벽하게 알고 있네요!',
            '맞았어요! 대단해요!',
            '훌륭해요! 정확히 맞혔어요!',
            '잘했어요! 정말 멋져요!',
        ],
        dontKnowSelect: [
            '괜찮아요! 같이 알아봐요!',
            '걱정 마세요! 예문을 보면 알 수 있어요!',
            '괜찮아요! 힌트를 보면 알 수 있어요!',
        ],
        maxAttempts: '괜찮아요. 어떤 어휘인지 같이 알아봐요!',
        maxAttemptsNext: '어떤 어휘인지 알아보고, 다음 어휘로 이동해요!',
    },
};
